import React from 'react';
import { useIsAdminOnBuyOrderEditForm } from '../../../../utils/buy-order/use-is-admin-on-buy-order-edit-form';
import { SubmitButton, SubmitButtonProps } from '../submit-button';

export function BuyProcessFormAdminSubmitButton(props: SubmitButtonProps) {
  const isAdminOnForm = useIsAdminOnBuyOrderEditForm();

  if (!isAdminOnForm) return null;

  return (
    <SubmitButton gutter={false} {...props}>
      {props.children}
    </SubmitButton>
  );
}
